const OPERATIONS = Object.freeze({
  card: { label:"Cartão/próxima data", route:"gravação do cartão" },
  stage: { label:"Estágio do cartão", route:"/api/crm/prospects/item" },
  prospect: { label:"Cartão/próxima data", route:"/api/crm/prospects/item" },
  reminder: { label:"Afazer", route:"/api/crm/reminders" },
  message: { label:"Mensagem", route:"/api/send-message" },
});

export function operationFailureMessage(operation, error, { uncertain = false } = {}) {
  const descriptor = OPERATIONS[error?.operation || operation] || OPERATIONS.card;
  const detail = typeof error === "string" ? error : error?.message;
  const networkFailure = /failed to fetch|fetch failed|networkerror|load failed/i.test(detail || "");
  const prefix = `${descriptor.label} (${descriptor.route}): `;
  if (detail?.startsWith(prefix)) return detail;
  if (networkFailure || uncertain || error?.uncertain === true) {
    return `${prefix}não foi possível confirmar o resultado da requisição. Ela pode ter sido recebida pelo servidor. Confira o estado antes de tentar novamente.${!networkFailure && detail ? ` ${detail}` : ""}`;
  }
  return `${prefix}${detail || "a operação não foi confirmada. Tente novamente."}`;
}

export function contextualizeProspectWriteError(error, operation) {
  const wrapped = new Error(operationFailureMessage(operation, error));
  wrapped.operation = operation;
  wrapped.code = error?.code;
  wrapped.uncertain = error?.uncertain === true
    || /failed to fetch|fetch failed|networkerror|load failed/i.test(error?.message || "");
  wrapped.cause = error;
  return wrapped;
}